module.exports = __webpack_public_path__ + "static/img/patent-swiper-1.1045b4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/patent-swiper-1.png
// module id = kDQo
// module chunks = 1